<div class="package-header-container  mat-typography">
    <div class="package-details-container"
         tabindex="0">
        <div class="package-detail">
            <span class="label">
                {{ type + '_versions_modal_grid_version' | translate }}:
            </span>
            <span class="detail"
                  data-cy="nuget-changelog-version">
                {{ package.version }}
            </span>
        </div>

        <div class="package-detail">
            <span class="label">
                {{ type + '_versions_modal_author' | translate }}:
            </span>
            <span class="detail"
                  data-cy="nuget-changelog-author">
                {{ package.authors }}
            </span>
        </div>

        <div class="package-detail">
            <span class="label">
                {{ type + '_versions_modal_grid_published' | translate }}:
            </span>
            <span class="detail">
                <ui-dateformat #publishedFormant
                               [matTooltip]="publishedFormant?.dataset['title']"
                               [date]="package.published"
                               contentType="relative">
                </ui-dateformat>
            </span>
        </div>

        <div *ngIf="type !== NugetType.Libraries"
             class="package-detail">
            <span class="label">
                {{ type + '_versions_modal_grid_status' | translate }}:
            </span>
            <span translate
                  class="detail"
                  data-cy="nuget-changelog-status">
                <ng-container *ngIf="package.isActive; else inactiveTmpl">
                    {{ type + '_versions_modal_grid_active' }}
                </ng-container>
                <ng-template #inactiveTmpl>
                    {{ type + '_versions_modal_grid_inactive' }}
                </ng-template>
            </span>
        </div>
    </div>

    <div [uiAuthorize]="'Processes.View'"
         class="download-package-container">
        <a *ngIf="isDownloadEnabled"
           [matTooltip]="type + '_versions_modal_grid_download' | translate"
           [href]="downloadLink"
           [uiClickTrack]="'Action: Grid: Download'"
           (click)="downloadPackage($event)"
           mat-icon-button
           target="_blank">
            <mat-icon>file_download</mat-icon>
        </a>
    </div>
</div>

<div *ngIf="!!package.releaseNotes"
     class="changelog  mat-typography"
     data-cy="nuget-changelog-releaseNotes">
    {{ package.releaseNotes }}
</div>
